import { MenuController } from '@ionic/angular/standalone';

import { TourService } from './tour.service';
import { GuidedTourEntry } from './tours';

/**
 * Launches a replayable guided tour from any hub (side menu, Settings): the
 * menu tour opens the panel first, page tours navigate via `startOnRoute`,
 * self-routing tours (the shell tour) just start. One implementation so the
 * hubs can't drift.
 */
export async function launchGuidedTour(
  tour: TourService,
  menuCtrl: MenuController,
  entry: GuidedTourEntry,
): Promise<void> {
  if (entry.opensMenu) {
    await menuCtrl.open();
    tour.start(entry.id, entry.steps);
    return;
  }
  if (entry.route) {
    await tour.startOnRoute(entry.id, entry.route, entry.steps);
    return;
  }
  tour.start(entry.id, entry.steps);
}
